<template>
  <div :class="['op--modal-container', {hide: !show}]" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="datetimepicker small-margin-v-s" @click.stop>
          <div class="row">
            <div class="column medium-6 small-12">
              <div class="title">
                <span v-if="charter.enabled && charter.datePicker === 'startDate'">{{ $t('rsvpEdit.selectStartDate') }}</span>
                <span v-else-if="charter.enabled && charter.datePicker === 'endDate'">{{ $t('rsvpEdit.selectEndDate') }}</span>
                <span v-else-if="forPickupDate">{{ $t('rsvpEdit.pickupDate') }}</span>
                <span v-else-if="isAirportPickup">{{ $t('rsvpEdit.arrivalDate') }}</span>
                <span v-else-if="isAirportDropoff">{{ $t('rsvpEdit.departureDate') }}</span>
                <span v-else>{{ $t('rsvpEdit.pickupDate') }}</span>
              </div>

              <datepicker :inline="true" :disabled="disabledDates" v-model="selectedDate"></datepicker>
            </div>

            <div class="column medium-6 small-12">
              <div class="pickuptime">
                <div class="title">
                  <span v-if="charter.enabled && charter.datePicker === 'startDate'">{{ $t('rsvpEdit.selectStartTime') }}</span>
                  <span v-else-if="charter.enabled && charter.datePicker === 'endDate'">{{ $t('rsvpEdit.selectEndTime') }}</span>
                  <span v-else-if="forPickupDate">{{ $t('rsvpEdit.pickupTime') }}</span>
                  <span v-else-if="isAirportPickup">{{ $t('rsvpEdit.arrivalTime') }}</span>
                  <span v-else-if="isAirportDropoff">{{ $t('rsvpEdit.departureTime') }}</span>
                  <span v-else>{{ $t('rsvpEdit.pickupTime') }}</span>
                </div>
                <span class="select">
                  <i :class="['fas fa-chevron-up increase fa-2x', hourClass.up]" @mousedown="hourClass.up = 'highlight'"
                    @mouseup="hourClass.up = ''" @click="adjustHour('up')"></i>
                  <div class="label">
                    <span>{{ pickupTime.hour }}</span>
                  </div>
                  <select v-model="pickupTime.hour">
                    <option v-for="x in maxHour" :value="leadingZero(x)" :key="x">{{ leadingZero(x) }}</option>
                  </select>
                  <i :class="['fas fa-chevron-down decrease fa-2x', hourClass.down]"  @mousedown="hourClass.down = 'highlight'"
                    @mouseup="hourClass.down = ''" @click="adjustHour('down')"></i>
                </span>
                <span>:</span>
                <span class="select">
                  <i :class="['fas fa-chevron-up increase fa-2x', minuteClass.up]" @mousedown="minuteClass.up = 'highlight'"
                    @mouseup="minuteClass.up = ''" @click="adjustMinute('up')"></i>
                  <div class="label">
                    <span>{{ pickupTime.minute }}</span>
                  </div>
                  <select v-model="pickupTime.minute">
                    <option value="00">00</option>
                    <option value="05">05</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="35">35</option>
                    <option value="40">40</option>
                    <option value="45">45</option>
                    <option value="50">50</option>
                    <option value="55">55</option>
                  </select>
                  <i :class="['fas fa-chevron-down decrease fa-2x', minuteClass.down]"  @mousedown="minuteClass.down = 'highlight'"
                    @mouseup="minuteClass.down = ''" @click="adjustMinute('down')"></i>
                </span>
                <span class="select" v-if="!isMilitaryTime">
                  <i :class="['fas fa-chevron-up increase fa-2x', ampmClass.up]" @mousedown="ampmClass.up = 'highlight'"
                    @mouseup="ampmClass.up = ''" @click="adjustAmPm('up')"></i>
                  <div class="label">
                    <span>{{ pickupTime.ampm }}</span>
                  </div>
                  <select v-model="pickupTime.ampm">
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                  <i :class="['fas fa-chevron-down decrease fa-2x', ampmClass.down]"  @mousedown="ampmClass.down = 'highlight'"
                    @mouseup="ampmClass.down = ''" @click="adjustAmPm('down')"></i>
                </span>
              </div>

              <div class="buttons">
                <div v-bind:class="{ 'error-message margin-t-s': true, hide: !pickupTimeError.show }">
                  {{ pickupTimeError.message }}
                </div>

                <a class="op-btn btn-lg btn-success btn-block margin-t-m" href="javascript:;"
                  @click="setPickupTime">
                  <span v-if="charter.enabled && charter.datePicker === 'endDate'">{{ $t('rsvpEdit.setEndTime') }}</span>
                  <span v-else-if="forPickupDate">{{ $t('rsvpEdit.setTime') }}</span>
                  <span v-else-if="isAirportPickup || isAirportDropoff">{{ $t('rsvpEdit.applyTime') }}</span>
                  <span v-else>{{ $t('rsvpEdit.setTime') }}</span>
                </a>

                <a class="close-btn" href="javascript:;" @click="close">{{ $t('common.cancel') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import Datepicker from 'vuejs-datepicker'
import ApiQuote from '@/modules/api/edit-quote'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'datetime-picker',
  components: { Datepicker },
  data () {
    return {
      pickupTime: {
        hour: null,
        minute: null,
        ampm: null
      },
      pickupTimeError: {
        show: false,
        message: ''
      },
      selectedDate: new Date(),
      // disabledDates: {
      //   to: new Date()
      // },
      today: moment.tz(this.$store.state.rsvpEdit.editedRsvp.pickupTimezone),
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      hourFormat: 'hh',
      hourClass: { up: '', down: '' },
      minuteClass: { up: '', down: '' },
      ampmClass: { up: '', down: '' }
    }
  },
  computed: {
    show () { return this.$store.state.rsvpEdit.dateTimePicker.show },
    isMilitaryTime () {
      if (this.$settings.get('MilitaryTimeWidget') && this.$settings.get('MilitaryTimeWidget') === '1') {
        this.hourFormat = 'HH'
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      }
      return this.$settings.get('MilitaryTimeWidget') && this.$settings.get('MilitaryTimeWidget') === '1'
    },
    isAirportPickup () { return this.$store.state.rsvpEdit.editedRsvp.pickup.geofenceType === 'airport' },
    isAirportDropoff () { return this.$store.state.rsvpEdit.editedRsvp.dropoff.geofenceType === 'airport' },
    forPickupDate () { return this.$store.state.rsvpEdit.dateTimePicker.forPickupDate },
    charter () { return this.$store.state.reservation.charter },
    disabledDates () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }
      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    }
  },
  watch: {
    show (value) {
      if (!value) { return }

      let self = this
      let time = self.$store.state.rsvpEdit.editedRsvp.pickupTime
      if ((self.isAirportPickup || self.isAirportDropoff) && self.$store.state.rsvpEdit.flightInfo.flightTime) {
        time = self.$store.state.rsvpEdit.flightInfo.flightTime
      }
      let pickupTime = moment(time, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      let selectedDate = new Date(
        parseInt(pickupTime.format('YYYY')),
        parseInt(pickupTime.format('MM') - 1),
        parseInt(pickupTime.format('DD')))
      self.selectedDate = selectedDate
      let buffer = parseInt(self.$settings.get('WebTimeBuffer'))
      // disable past dates
      let now = moment().add(buffer, 'minute') // .tz(self.$store.state.rsvpEdit.editedRsvp.pickupTimezone)
      self.disabledDates = {
        to: new Date(now.year(), now.month(), now.date())
      }

      self.pickupTime.hour = pickupTime.format(self.hourFormat)
      self.pickupTime.minute = pickupTime.format('mm')
      self.pickupTime.ampm = pickupTime.format('A')
      self.pickupTimeError.show = false
    }
  },
  methods: {
    close () {
      this.$store.commit('rsvpEdit/hideDateTimePicker')
      this.$store.commit('rsvpEdit/setForPickupDate', false)
    },
    leadingZero (x) {
      x = x + ''
      return x.length === 1 ? '0' + x : x
    },
    setPickupTime () {
      let self = this
      self.pickupTimeError.show = false
      let pickupDate = moment(self.selectedDate)
      let pickupTimezone = self.$store.state.rsvpEdit.editedRsvp.pickupTimezone

      let dateStr = pickupDate.month() + 1
      dateStr += '/'
      dateStr += pickupDate.date()
      dateStr += '/'
      dateStr += pickupDate.year()
      dateStr += ' '
      dateStr += self.pickupTime.hour
      dateStr += ':'
      dateStr += self.pickupTime.minute
      if (!self.isMilitaryTime) {
        dateStr += ''
        dateStr += self.pickupTime.ampm
      }

      let finalResult = moment.tz(dateStr, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false), pickupTimezone)
      // let buffer = parseInt(self.$settings.get('WebTimeBuffer'))
      // disable past dates
      // let now = moment().add(buffer, 'minute')
      let now = moment.tz(pickupTimezone)

      if (finalResult.isBefore(now)) {
        self.pickupTimeError.show = true
        // self.pickupTimeError.message = `${self.$t('rsvpEdit.buffer1')} ${buffer} ${self.$t('rsvpEdit.buffer2')}`
        self.pickupTimeError.message = self.$t('rsvpEdit.selectDatePast')
        return
      }
      if (self.charter.enabled) {
        let _date = {}
        if (self.charter.datePicker !== 'flightDate') {
          _date[self.charter.datePicker] = finalResult.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
          let startDate = moment(self.charter.datePicker === 'startDate' ? dateStr : self.charter.startDate, 'MM/DD/YYYY hh:mmA')
          let endDate = moment(self.charter.datePicker === 'endDate' ? dateStr : self.charter.endDate, 'MM/DD/YYYY hh:mmA')
          let duration = moment(self.charter.endDate, 'MM/DD/YYYY hh:mmA').diff(moment(self.charter.startDate, 'MM/DD/YYYY hh:mmA'), 'minutes')
          if (self.charter.datePicker === 'startDate') {
            self.$store.commit('reservation/setCharterData', {endDate: moment(dateStr, 'MM/DD/YYYY hh:mmA').add(duration, 'minutes').format('MM/DD/YYYY hh:mmA')})
          }
          if (self.charter.datePicker === 'endDate') {
            if (startDate && endDate && startDate.diff(endDate, 'minutes') > 0) {
              self.pickupTimeError.show = true
              self.pickupTimeError.message = self.$t('rsvpEdit.EndDateMust')
              return
            }
            if (startDate && endDate && endDate.diff(startDate, 'minutes') > self.charter.maxDuration) {
              self.pickupTimeError.show = true
              let time = moment.duration(self.charter.maxDuration, 'minutes').humanize({h: Infinity})
              self.pickupTimeError.message = self.$t('rsvpEdit.maxDurationFor', {time: time})
              return
            }
            self.$store.commit('reservation/setCharterData', {endDate: endDate.format('MM/DD/YYYY hh:mmA')})
            if (startDate && endDate && self.charter.startDate === self.charter.endDate) {
              self.pickupTimeError.show = true
              self.pickupTimeError.message = self.$t('rsvpEdit.invalidDateRange')
              return
            }
          }

          _date[self.charter.datePicker] = finalResult.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
          self.$store.commit('reservation/setCharterData', _date)
        } else {
          self.$store.commit('rsvpEdit/setFlightTime', finalResult.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)))
          self.$emit('openFlightInfo')
        }
      } else if (self.forPickupDate) {
        self.$store.commit('rsvpEdit/setEditedPickupTime', finalResult.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)))
      } else if (self.isAirportPickup || self.isAirportDropoff) {
        self.$store.commit('rsvpEdit/setFlightTime', finalResult.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)))
        self.$emit('openFlightInfo')
      } else {
        self.$store.commit('rsvpEdit/setEditedPickupTime', finalResult.format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)))
      }
      self.close()
      if (!self.charter.enabled) {
        // ApiQuote.updateSelectedService(self)
        ApiQuote.getQuote(self, true)
      } else {
        if (self.charter.datePicker === 'endDate') {
          ApiQuote.getQuote(self)
        }
      }
    },
    adjustHour (direction) {
      let hourFormat = this.$settings.get('MilitaryTimeWidget') && this.$settings.get('MilitaryTimeWidget') === '1' ? 'HH' : 'hh'
      if (direction === 'up') {
        this.pickupTime.hour = moment(this.pickupTime.hour, 'hh').add(1, 'hour').format(hourFormat)
      } else {
        this.pickupTime.hour = moment(this.pickupTime.hour, 'hh').subtract(1, 'hour').format(hourFormat)
      }
    },
    adjustMinute (direction) {
      if (direction === 'up') {
        this.pickupTime.minute = moment(this.pickupTime.minute, 'mm').add(5, 'minutes').format('mm')
      } else {
        this.pickupTime.minute = moment(this.pickupTime.minute, 'mm').subtract(5, 'minutes').format('mm')
      }
    },
    adjustAmPm (direction) {
      this.pickupTime.ampm = this.pickupTime.ampm === 'AM' ? 'PM' : 'AM'
    }
  }
}
</script>

<style lang="scss" scoped>
.datetimepicker {
  background-color: #fff;
  max-width: 600px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 10px;
  }

  & .separator {
    &::after {
      content: "or";
    }
  }
}

.pickuptime{
  text-align: center;
  display: block;
  /*margin-top: 20px;*/

  & .title { margin-bottom: 20px; }

  & .select{
    position: relative;
    display: inline-block;
    /*border-bottom: 1px solid rgba(0,0,0 ,0.35);*/
    width: 50px;
    text-align: center;
    margin: 25px 10px 0;

    & .label{
      padding: 10px 10px 5px;
      font-size: 22px;
      line-height: 22px;

      & .icon{
        float: right;
      }
    }
    .fas{
      left: 50%;
      padding: 0 5px;
      color: #495057;
      cursor: pointer;
      position: absolute;
      transform: translateX(-50%);
      transition: all .2s ease-out;

      &.increase{ top: -30px; }
      &.decrease{ top: calc(100% + 3px); }
      &.highlight{ background: #d2f0ff; }
    }

    & select{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    &.border{
      border-left: 0;
    }
  }
}

.buttons{
  padding-left: 15px;
  margin-top: 50px;
}

.close-btn {
  display: block;
  text-align: center;
  margin-top: 15px;
  color: #cb8112;
}

.error-message {
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  background-color: #EB5837;
  display: block;
  &.hide { display: none; }
}

@media only screen and (max-width: 639px) {
  .pickuptime{ margin-top: 20px; }
}
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?23fb3452